import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import deLocale from 'date-fns/locale/de';
import enLocale from 'date-fns/locale/en-US';
import esLocale from 'date-fns/locale/es';
import frLocale from 'date-fns/locale/fr';

import {Locale} from '../shapes/locale';


const getTimeElapsedSinceCreation = (locale: Locale, createdAt: Date): string => {
  let commentLocale;

  switch (locale) {
    case 'de': {
      commentLocale = deLocale;
      break;
    }
    case 'es': {
      commentLocale = esLocale;
      break;
    }
    case 'fr': {
      commentLocale = frLocale;
      break;
    }

    default:
      commentLocale = enLocale;
  }

  return (
    formatDistanceToNow(createdAt, {
      locale: commentLocale,
      addSuffix: true
    })
  );
};

export default getTimeElapsedSinceCreation;
